document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.carousel-track');
  const slides = document.querySelectorAll('.carousel-slide');
  const container = document.querySelector('.carousel-container');
  
  if (!track || !slides.length || !container) return;

  let currentIndex = 0;
  let startX = 0;
  let isDragging = false;
  const totalSlides = slides.length;
  
  // Clona le slide per creare l'effetto infinito
  function setupInfiniteCarousel() {
    const slideWidth = slides[0].offsetWidth;
    
    // Clona le slide originali e le aggiunge alla fine
    slides.forEach((slide, index) => {
      const clone = slide.cloneNode(true);
      track.appendChild(clone);
    });
    
    // Clona le slide originali e le aggiunge all'inizio
    for (let i = slides.length - 1; i >= 0; i--) {
      const clone = slides[i].cloneNode(true);
      track.insertBefore(clone, track.firstChild);
    }
    
    // Aggiorna currentIndex per iniziare dalle slide originali (al centro)
    currentIndex = totalSlides;
  }
  
  function updateCarousel() {
    const slideWidth = slides[0].offsetWidth;
    const containerWidth = container.offsetWidth;
    const offset = (containerWidth - slideWidth) / 2;
    const translateX = -currentIndex * slideWidth + offset;
    
    track.style.transform = `translateX(${translateX}px)`;
    
    // Aggiorna la classe 'center' solo per le slide visibili
    const allSlides = document.querySelectorAll('.carousel-slide');
    allSlides.forEach((slide, index) => {
      slide.classList.remove('center');
    });
    
    if (allSlides[currentIndex]) {
      allSlides[currentIndex].classList.add('center');
    }
  }
  
  function goToSlide(index) {
    currentIndex = index;
    updateCarousel();
    
    // Gestione dell'infinito loop
    const allSlides = document.querySelectorAll('.carousel-slide');
    const totalAllSlides = allSlides.length;
    
    setTimeout(() => {
      track.style.transition = 'none';
      
      // Se siamo troppo a destra, torna alle slide originali
      if (currentIndex >= totalAllSlides - totalSlides) {
        currentIndex = totalSlides + (currentIndex - (totalAllSlides - totalSlides));
        updateCarousel();
      }
      
      // Se siamo troppo a sinistra, torna alle slide originali  
      if (currentIndex < totalSlides) {
        currentIndex = totalAllSlides - totalSlides + currentIndex;
        updateCarousel();
      }
      
      setTimeout(() => {
        track.style.transition = 'transform 0.5s ease-out';
      }, 50);
    }, 500);
  }
  
  function goNext() {
    goToSlide(currentIndex + 1);
  }
  
  function goPrev() {
    goToSlide(currentIndex - 1);
  }
  
  // Touch events per mobile
  container.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    isDragging = true;
  }, { passive: true });
  
  container.addEventListener('touchmove', function(e) {
    if (!isDragging) return;
    e.preventDefault();
  }, { passive: false });
  
  container.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    isDragging = false;
    
    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;
    const threshold = 50;
    
    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        goNext();
      } else {
        goPrev();
      }
    }
  }, { passive: true });
  
  // Mouse drag per desktop
  container.addEventListener('mousedown', function(e) {
    startX = e.clientX;
    isDragging = true;
    e.preventDefault();
  });
  
  container.addEventListener('mousemove', function(e) {
    if (!isDragging) return;
    e.preventDefault();
  });
  
  container.addEventListener('mouseup', function(e) {
    if (!isDragging) return;
    isDragging = false;
    
    const endX = e.clientX;
    const diffX = startX - endX;
    const threshold = 50;
    
    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        goNext();
      } else {
        goPrev();
      }
    }
  });
  
  container.addEventListener('mouseleave', function() {
    isDragging = false;
  });
  
  // Inizializzazione
  setupInfiniteCarousel();
  updateCarousel();

  // Gestione resize
  window.addEventListener('resize', updateCarousel);
});